// extracted by mini-css-extract-plugin
export default {"container":"Dc4rKQUYZYqu2hBHjpXMDg==","link":"ERjSNEuDWnFmR6fhCHtGww=="};